import { OktaAuth } from "@okta/okta-auth-js";
import { config } from "config";

export const oktaAuth = new OktaAuth(config.oktaAuthOptions);
